import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';

export default function Icon1Capp({ className, ...rest }) {
    return (
        <svg
            height="16"
            width="16"
            viewBox="0 0 370 238.858"
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <path
                d="M254.137 207.078c-9.465-.631-20.38-2.29-28.988-4.783-1.612-.468-8.288-2.922-9.987-3.7-29.969-13.883-50.847-44.187-50.847-79.345 0-48.222 39.232-87.5 87.485-87.5 47.825 0 86.792 38.608 87.462 86.285h31.605C370.197 52.939 317.059.183 251.8.183c-65.649 0-119.082 53.403-119.082 119.067 0 45.27 25.458 84.642 62.735 104.756 6.73 3.56 16.39 7.23 19.67 8.235 10.626 3.162 23.667 5.266 35.275 6.146 3.942.296 17.707.452 21.72.468h217.645v-31.481h-217.28c-2.89 0-15.518-.11-18.346-.296m18.346-49.43c-2.298 0-14.318-.077-16.539-.264-3.762-.32-9.215-.88-12.721-1.683-3.958-1.06-7.674-2.462-9.348-3.381-11.74-6.35-19.741-18.767-19.741-33.07 0-20.808 16.85-37.682 37.666-37.682 20.38 0 36.95 16.212 37.612 36.467h30.366C319.14 81.03 288.975 51.21 251.8 51.21c-37.588 0-68.056 30.46-68.056 68.04 0 26.503 15.191 49.39 37.316 60.6 3.404 1.995 9.807 4.083 11.63 4.558 6.248 1.644 14.638 2.766 21.447 3.264 2.516.21 14.84.304 17.443.32v.046h218.175v-30.39zm-159.241 81.09H81.426V31.819H34.934V-.004h78.308zM.002 47.719v30.6h34.932v160.419h30.569V47.719z"
                className={css.colored}
            />
        </svg>
    );
}
